import script from "./AppBreadCrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBreadCrumbs.vue?vue&type=script&setup=true&lang=js"

import "./AppBreadCrumbs.vue?vue&type=style&index=0&id=e5a4b59a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5a4b59a"]])

export default __exports__